// @mui
import {
  TableContainer,
  Table,
  TableHead,
  TableCell,
  TableBody,
  TableRow,
} from '@mui/material';
// hooks
import useCompany from '../../hooks/useCompany';
// components
import Scrollbar from '../../components/Scrollbar';
import {
  CompanyTableRow,
} from './';


const TABLE_HEAD = [
  { id: 'name', label: '회사 이름', align: 'center' },
  { id: 'status', label: '계약 상태', align: 'center' },
  { id: 'endDate', label: '계약 종료일', align: 'center' },
  { id: 'link' },
];

export default function CompanyTable() {
  const { company } = useCompany();

  return (
    <Scrollbar>
      <TableContainer sx={{ py: 2, px: 1 }}>
      <Table size={'medium'}>
        <CompanyTableHead
          headLabel={TABLE_HEAD}
          sx={{ whiteSpace: 'nowrap' }}
        />
        <TableBody>
          {company && company.map((row) => (
            <CompanyTableRow
              key={row.id}
              row={row}
            />
          ))}
        </TableBody>
      </Table>
      </TableContainer>
    </Scrollbar>
  )
}

function CompanyTableHead({
  headLabel,
  sx,
}) {
  return (
    <TableHead sx={sx}>
      <TableRow>
        {headLabel.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.align || 'left'}
            sx={{ width: headCell.width, minWidth: headCell.minWidth }}
          >
            {headCell.label}
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}
